<template>
  <div class="grid pb-0">
    <div class="grid-title-tab">
      <div class="d-grid-title">
        <h4>{{ $t("PRICE_ALLOCATION") }}</h4>
        <v-btn class="mt-0 mr-2" color="" @click="$router.push({ name: 'package' })">
          <v-icon light size="20px" left>table_chart</v-icon>
          {{ $t("PACKAGE_DEAL") }}
        </v-btn>
      </div>
      <v-progress-linear
        color="warning"
        indeterminate
        rounded
        height="3"
        v-if="isLoading"
      ></v-progress-linear>
      <div class="grid-body border-top-unset" v-if="dataWeekly">
        <div class="p-3">
          <h6>{{dataWeekly.roomType.roomTypeI18n.find((e) => e.lang === defaultI18n).name}}</h6>
          <h6>
            {{ dataWeekly.ratePlan.i18ns.find((e) => e.lang === defaultI18n).name }} - ({{
              $t("HOTEL_LOG_id")
            }}: {{ dataWeekly.ratePlan.ratePlanCode }})
          </h6>
        </div>
        <div class="px-3">
          <v-row>
            <v-col sm="4">
              <v-btn-toggle v-model="tab" color="primary" dense group>
                <v-btn :value="item.key" v-for="item in tabItems">
                  {{ item.title }}
                </v-btn>
              </v-btn-toggle>
            </v-col>
            <v-col class="d-flex align-items-center">
              <v-radio-group
                class="pt-0"
                v-model="dataWeekly.roomRatePackagesDTO.roomRatePackageDTOS[0].percent"
                row
                @change="($event) => changePercent($event, true)"
              >
                <v-radio
                  :label="`% ${$t('PERCENT')}`"
                  :value="true"
                  :disabled="tab === 'daily'"
                ></v-radio>
                <v-radio
                :label="`$ ${$t('AMOUNT_OF_MONEY')}`"
                  :value="false"
                  :disabled="tab === 'daily'"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-col class="d-flex align-items-center justify-content-end fs-12">
              <b class="pt-3">
                {{$t('UNIT')}} : {{dataWeekly.roomRatePackagesDTO.roomRatePackageDTOS[0].percent ? '%' : currency}}
              </b>
            </v-col>
          </v-row>
        </div>
        <div v-if="tab === 'weekly'" class="px-3 config-price">
          <v-form ref="formUpdate" lazy-validation>
            <v-row class="d-sticky">
              <v-col md="2" class="pt-0 pb-0 d-flex align-items-center">
                <b>{{$t('SERVICE_INCLUDES')}}</b>
              </v-col>
              <v-col md="10" class="pt-0 pb-0">
                <v-row>
                  <v-col
                    class="text-center font-weight-bold"
                    v-for="item in daysOfWeek"
                    :key="item.value"
                    >{{ item.value }}</v-col
                  >
                </v-row>
              </v-col>
            </v-row>
            <v-row
              class="mt-3 border-bottom pb-3"
              v-for="(sv, ind) in dataWeekly.roomRatePackagesDTO.roomRatePackageDTOS"
              :key="ind"
            >
              <v-col md="2" class="fs-12 py-0">
                <div class="d-flex align-items-center h-100">
                  <div
                    class="text-truncate mr-auto"
                    style="max-width: 200px"
                    :title="
                      sv.serviceStaticMinimalDTO.serviceStaticI18ns.find(
                        (e) => e.lang === defaultI18n
                      ).name
                    "
                  >
                    {{
                      sv.serviceStaticMinimalDTO.serviceStaticI18ns.find(
                        (e) => e.lang === defaultI18n
                      ).name
                    }}
                  </div>
                  <div>&#215; {{ sv.nos }}</div>
                </div>
              </v-col>
              <v-col md="10" class="pb-0 pt-0">
                <v-row class="small-gutters update-weekly">
                  <v-col class="pb-0 pt-0 d-flex">
                    <v-icon
                      size="16"
                      color="primary"
                      @click="copyPrice(sv)"
                      class="pr-3"
                      :title="$t('COPY')"
                    >
                      content_paste_go</v-icon
                    >
                    <v-text-field
                      :class="currency == 'VND' ? 'text-right-input' : ''"
                      :options="optionFormat"
                      dense
                      outlined
                      :value="computedPrice(ind, 'priceMonday').get()"
                      @input="handleInput($event, ind, 'priceMonday')"
                      @keydown="keyCurrencyDown($event,currency, false, isPercent)"
                      v-bind:prefix="!isPercent && prefixCurrency"
                      v-bind:suffix="!isPercent && suffixCurrency"
                      :key="`priceMonday_${ind}_${reloadKey}`"
                      :ref="`input_${ind}_priceMonday`"
                    />
                  </v-col>
                  <v-col class="pb-0 pt-0">
                    <v-text-field
                      :class="currency == 'VND' ? 'text-right-input' : ''"
                      :options="optionFormat"
                      dense
                      outlined
                      :value="computedPrice(ind, 'priceTuesday').get()"
                      @input="handleInput($event, ind, 'priceTuesday')"
                      @keydown="keyCurrencyDown($event,currency, false, isPercent)"
                      v-bind:prefix="!isPercent && prefixCurrency"
                      v-bind:suffix="!isPercent && suffixCurrency"
                      :key="`priceTuesday_${ind}_${reloadKey}`"
                      :ref="`input_${ind}_priceTuesday`"
                    />
                  </v-col>
                  <v-col class="pb-0 pt-0">
                    <v-text-field
                      :class="currency == 'VND' ? 'text-right-input' : ''"
                      :options="optionFormat"
                      dense
                      outlined
                      :value="computedPrice(ind, 'priceWednesday').get()"
                      @input="handleInput($event, ind, 'priceWednesday')"
                      @keydown="keyCurrencyDown($event,currency, false, isPercent)"
                      v-bind:prefix="!isPercent && prefixCurrency"
                      v-bind:suffix="!isPercent && suffixCurrency"
                      :key="`priceWednesday_${ind}_${reloadKey}`"
                      :ref="`input_${ind}_priceWednesday`"
                    />
                  </v-col>
                  <v-col class="pb-0 pt-0">
                    <v-text-field
                      :class="currency == 'VND' ? 'text-right-input' : ''"
                      :options="optionFormat"
                      dense
                      outlined
                      :value="computedPrice(ind, 'priceThursday').get()"
                      @input="handleInput($event, ind, 'priceThursday')"
                      @keydown="keyCurrencyDown($event,currency, false, isPercent)"
                      v-bind:prefix="!isPercent && prefixCurrency"
                      v-bind:suffix="!isPercent && suffixCurrency"
                      :key="`priceThursday_${ind}_${reloadKey}`"
                      :ref="`input_${ind}_priceThursday`"
                    />
                  </v-col>
                  <v-col class="pb-0 pt-0">
                    <v-text-field
                      :class="currency == 'VND' ? 'text-right-input' : ''"
                      :options="optionFormat"
                      dense
                      outlined
                      :value="computedPrice(ind, 'priceFriday').get()"
                      @input="handleInput($event, ind, 'priceFriday')"
                      @keydown="keyCurrencyDown($event,currency, false, isPercent)"
                      v-bind:prefix="!isPercent && prefixCurrency"
                      v-bind:suffix="!isPercent && suffixCurrency"
                      :key="`priceFriday_${ind}_${reloadKey}`"
                      :ref="`input_${ind}_priceFriday`"
                    />
                  </v-col>
                  <v-col class="pb-0 pt-0">
                    <v-text-field
                      :class="currency == 'VND' ? 'text-right-input' : ''"
                      :options="optionFormat"
                      dense
                      outlined
                      :value="computedPrice(ind, 'priceSaturday').get()"
                      @input="handleInput($event, ind, 'priceSaturday')"
                      @keydown="keyCurrencyDown($event,currency, false, isPercent)"
                      v-bind:prefix="!isPercent && prefixCurrency"
                      v-bind:suffix="!isPercent && suffixCurrency"
                      :key="`priceSaturday_${ind}_${reloadKey}`"
                      :ref="`input_${ind}_priceSaturday`"
                    />
                  </v-col>
                  <v-col class="pb-0 pt-0">
                    <v-text-field
                      :class="currency == 'VND' ? 'text-right-input' : ''"
                      :options="optionFormat"
                      dense
                      outlined
                      :value="computedPrice(ind, 'priceSunday').get()"
                      @input="handleInput($event, ind, 'priceSunday')"
                      @keydown="keyCurrencyDown($event,currency, false, isPercent)"
                      v-bind:prefix="!isPercent && prefixCurrency"
                      v-bind:suffix="!isPercent && suffixCurrency"
                      :key="`priceSunday_${ind}_${reloadKey}`"
                      :ref="`input_${ind}_priceSunday`"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="mt-3 max-fix">
              <v-col md="2" class="fs-12 text-truncate">
                <b>{{ $t("MIN_ROOM_RATE") }}</b>
              </v-col>
              <v-col md="10" class="pb-0 pt-0">
                <v-row class="small-gutters">
                  <v-col class="pb-0 pt-0">
                    <vuetify-number
                      :class="currency == 'VND' ? roomOnly.priceMonday < 0 ? 'text-right-input text-danger-package' : 'text-right-input text-dark-package' : ''"
                      :options="optionFormat"
                      outlined
                      dense
                      disabled
                      v-model="roomOnly.priceMonday"
                      :rules="[validateMax('priceMonday') || '']"
                      class="total-package-value font-weight-bold" 
                    />
                  </v-col>
                  <v-col class="pb-0 pt-0">
                    <vuetify-number
                    :class="currency == 'VND' ? roomOnly.priceTuesday < 0 ? 'text-right-input text-danger-package' : 'text-right-input text-dark-package' : ''"
                      :options="optionFormat"
                      dense
                      outlined
                      disabled
                      v-model="roomOnly.priceTuesday"
                      :rules="[validateMax('priceTuesday') || '']"
                      class="total-package-value font-weight-bold"
                    />
                  </v-col>
                  <v-col class="pb-0 pt-0">
                    <vuetify-number
                      :class="currency == 'VND' ? roomOnly.priceWednesday < 0 ? 'text-right-input text-danger-package' : 'text-right-input text-dark-package' : ''"
                      :options="optionFormat"
                      dense
                      outlined
                      disabled
                      v-model="roomOnly.priceWednesday"
                      :rules="[validateMax('priceWednesday') || '']"
                      class="total-package-value font-weight-bold"
                    />
                  </v-col>
                  <v-col class="pb-0 pt-0">
                    <vuetify-number
                      :class="currency == 'VND' ? roomOnly.priceThursday < 0 ? 'text-right-input text-danger-package' : 'text-right-input text-dark-package' : ''"
                      :options="optionFormat"
                      dense
                      outlined
                      disabled
                      v-model="roomOnly.priceThursday"
                      :rules="[validateMax('priceThursday') || '']"
                      class="total-package-value font-weight-bold"
                    />
                  </v-col>
                  <v-col class="pb-0 pt-0">
                    <vuetify-number
                      :class="currency == 'VND' ? roomOnly.priceFriday < 0 ? 'text-right-input text-danger-package' : 'text-right-input text-dark-package' : ''"
                      :options="optionFormat"
                      dense
                      outlined
                      disabled
                      v-model="roomOnly.priceFriday"
                      :rules="[validateMax('priceFriday') || '']"
                      class="total-package-value font-weight-bold"
                    />
                  </v-col>
                  <v-col class="pb-0 pt-0">
                    <vuetify-number
                      :class="currency == 'VND' ? roomOnly.priceSaturday < 0 ? 'text-right-input text-danger-package' : 'text-right-input text-dark-package' : ''"
                      :options="optionFormat"
                      dense
                      outlined
                      disabled
                      v-model="roomOnly.priceSaturday"
                      :rules="[validateMax('priceSaturday') || '']"
                      class="total-package-value font-weight-bold"
                    />
                  </v-col>
                  <v-col class="pb-0 pt-0">
                    <vuetify-number
                      :class="currency == 'VND' ? roomOnly.priceSunday < 0 ? 'text-right-input text-danger-package' : 'text-right-input text-dark-package' : ''"
                      :options="optionFormat"
                      dense
                      outlined
                      disabled
                      v-model="roomOnly.priceSunday"
                      :rules="[validateMax('priceSunday') || '']"
                      class="total-package-value font-weight-bold"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <div class="text-right py-3" v-if="!isLoading">
              <v-btn color="primary" @click="confirmUpdatePriceWeekly()">
                <template>{{ $t("UPDATE") }}</template>
              </v-btn>
            </div>
          </v-form>
        </div>
        <div v-if="tab === 'daily'" class="px-3 config-price d-date">
          <v-row class="d-sticky">
            <v-col md="3" class="font-weight-bold"> {{ $t("DATE_RANGE") }} </v-col>
            <v-col class="py-0">
              <v-row>
                <v-col class="font-weight-bold pl-5">{{ $t("SERVICES") }} </v-col>
                <v-col md="1" class="font-weight-bold pl-5 text-right">{{ $t("_BOOKING_DETAIL.SERVICE.COUNT") }} </v-col>
                <v-col md="2" class="font-weight-bold text-right"> {{ $t("PRICE_ALLOCATION") }} </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-form ref="formUpdateDaily" lazy-validation>
            <v-row
              v-for="(date, indexDate) in massDate"
              class="small-gutters border-bottom mr-0"
              v-if="date.action !== 3"
              :key="indexDate"
            >
              <v-col class="py-3 d-flex align-items-center" md="3">
                <date-picker
                  :confirm="true"
                  :confirm-text="$t('CONFIRM')"
                  :clearable="false"
                  :popup-class="'popup-calendar-desktop-detailhotel'"
                  :lang="languageDate"
                  v-model="date.dateSelect"
                  :format="'DD/MM/YYYY'"
                  :shortcuts="[]"
                  range
                  placeholder="Select date range"
                >
                </date-picker>
                <v-icon
                  class="ml-3"
                  v-if="massDate.length > 0"
                  color="red"
                  size="16"
                  @click="date.action = 3"
                  >delete
                </v-icon>
              </v-col>
              <v-col style="padding-right: 0 !important" class="border-left py-0">
                <v-row
                  v-for="(sv, indsv) in date.services"
                  class="m-0 fs-12 border-bottom"
                  :key="indsv + indexDate + 'a'"
                >
                  <v-col class="py-0 d-flex align-items-center">
                    {{ sv.serviceStaticI18ns.find((e) => e.lang === defaultI18n).name }}
                  </v-col>
                  <v-col md="1" class="font-weight-bold text-right d-flex align-items-center justify-content-end">{{sv.nos}} </v-col>
                  <v-col md="2" class="pr-0">
                    <v-text-field
                      :class="currency == 'VND' ? 'text-right-input' : ''"
                      :options="optionFormat"
                      dense
                      outlined
                      :value="computedPriceByDay(indexDate, indsv).get()"
                      @input="handleInputByDay($event, indexDate, indsv)"
                      @keydown="keyCurrencyDown($event,currency, false, isPercent)"
                      :key="`row_${indexDate}_service_${indsv}_key_${reloadKey}`"
                      :ref="`row_${indexDate}_service_${indsv}`"
                    />
                  </v-col>
                </v-row>
                <v-row class="m-0 fs-12 max-fix">
                  <v-col class="py-0 d-flex align-items-center">
                    <b>{{ $t("MIN_ROOM_RATE") }}</b>
                  </v-col>
                  <v-col md="2" class="py-0 pr-0">
                    <vuetify-number
                      :class="currency == 'VND' ? !validateMaxDaily(date) ? 'text-right-input text-danger-package' : 'text-right-input text-dark-package' : ''"
                      :options="optionFormat"
                      dense
                      outlined
                      disabled
                      v-model="date.min"
                      :rules="[validateMaxDaily(date) || '']"
                      class="total-package-value font-weight-bold"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="mt-1">
              <v-col class="pt-0 pb-0">
                <v-btn color="primary" outlined x-small @click="addDateSpecial()">
                  <v-icon color="#173d8f" small>add</v-icon>
                  <span class="fs-8">{{ $t("ADD_DATE_RANGE") }}</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
          <div class="text-right py-3" v-if="!isLoading">
            <v-btn color="primary" @click="confirmUpdatePriceDaily()">
              <template>{{ $t("UPDATE") }}</template>
            </v-btn>
          </div>
        </div>
      </div>
      <!--  -->
    </div>
    <confirm-dialog
      @deleteItem="updatePriceWeekly"
      :maxWidth="325"
      :persistent="true"
      ref="confirmDialogComponent"
    >
      <span slot="title"
        >{{ $t("CONFIRM_UPDATE_PRICE_SERVICE_GREATER_THAN_TOTAL_PACKAGE")}}</span
      >
    </confirm-dialog>
    <confirm-dialog
      @deleteItem="updatePriceDaily"
      :maxWidth="325"
      :persistent="true"
      ref="confirmDailyDialogComponent"
    >
      <span slot="title"
        >{{ $t("CONFIRM_UPDATE_PRICE_SERVICE_GREATER_THAN_TOTAL_PACKAGE")}}</span
      >
    </confirm-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { _formatCurrency, _formatDate, _alert } from "@/_helpers/function.js";
import { serviceCombo } from "@/_services/Combo/Combo.service.js";
import { validate } from "json-schema";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import ConfirmDialog from "@/components/Utils/ConfirmDialog.vue";
export default {
  components: {
    "date-picker": DatePicker,
    "confirm-dialog": ConfirmDialog,
  },
  data() {
    return {
      isLoading: false,
      systemLang: this.$i18n.locale,
      dataWeekly: null,
      tab: "weekly",
      daysOfWeek: [
        { code: "MON", value: this.$t("MONDAY") },
        { code: "TUE", value: this.$t("TUESDAY") },
        { code: "WED", value: this.$t("WEDNESDAY") },
        { code: "THU", value: this.$t("THURSDAY") },
        { code: "FRI", value: this.$t("FRIDAY") },
        { code: "SAT", value: this.$t("SATURDAY") },
        { code: "SUN", value: this.$t("SUNDAY") },
      ],
      currency: JSON.parse(localStorage.getItem("currency")),
      percentOptionsVi: {
        type: null,
        suffix: "",
        locale: "vi",
        length: 3,
        precision: 0,
      },
      optionFormat: {
        type: 'currency',
        suffix: "",
        locale: "vi",
        length: 8,
        precision: 0,
      },
      maxUpdate: {
        priceFriday: 0,
        priceMonday: 0,
        priceSaturday: 0,
        priceSunday: 0,
        priceThursday: 0,
        priceTuesday: 0,
        priceWednesday: 0,
      },
      roomOnly: {
        priceFriday: 0,
        priceMonday: 0,
        priceSaturday: 0,
        priceSunday: 0,
        priceThursday: 0,
        priceTuesday: 0,
        priceWednesday: 0,
      },

      dataDaily: null,
      massDate: [],
      currentDate: moment().startOf("day").toDate(),
      serviceOfRoomRate: null,
      timeout: null,
      reloadKey: 0,
    };
  },
  computed: {
    isPercent() {
      return this.dataWeekly.roomRatePackagesDTO.roomRatePackageDTOS[0].percent == true;
    },
    computedPrice() {
      return (indx, date) => ({
        get: () => {
          return this.convertDecimalViaLocal(this.dataWeekly.roomRatePackagesDTO.roomRatePackageDTOS[indx][date]) || "";
        },
        set: (value) => {
          this.$set(this.dataWeekly.roomRatePackagesDTO.roomRatePackageDTOS[indx], date, value);
        }
      });
    },
    computedPriceByDay() {
      return (parentIdx, childrenIdx) => ({
        get: () => {
          return this.convertDecimalViaLocal(this.massDate[parentIdx].services[childrenIdx].price) || "";
        },
        set: (value) => {
          this.$set(this.massDate[parentIdx].services[childrenIdx], 'price', value);
        }
      });
    },
    tabItems() {
      return [
        {
          title: this.$t("WEEKLY_PRICE"),
          key: "weekly",
        },
        {
          title: this.$t("DAILY_PRICE"),
          key: "daily",
        },
      ];
    },
  },
  created() {
    this.currency = this.priceOptionsVi.suffix;
    const urlParams = new URLSearchParams(window.location.search);
    this.getRoomRatePackageWeekly(this.$route.params.id);
  },
  watch: {
    dataWeekly: {
      handler(val) {
        this.roomOnly = Object.assign({}, this.maxUpdate)
        val.roomRatePackagesDTO.roomRatePackageDTOS.forEach(e => {
          this.roomOnly.priceMonday += -e.priceMonday;
          this.roomOnly.priceFriday += -e.priceFriday;
          this.roomOnly.priceSaturday += -e.priceSaturday;
          this.roomOnly.priceSunday += -e.priceSunday;
          this.roomOnly.priceThursday += -e.priceThursday;
          this.roomOnly.priceTuesday += -e.priceTuesday;
          this.roomOnly.priceWednesday += -e.priceWednesday;
        })
      },
      deep: true,
    },
    maxUpdate: {
      handler(val) {
        this.getRoomRatePackageDaily();
      },
      deep: true,
    },
    massDate: {
      handler(val) {
        val.forEach((date) => {
          date.weekdays = [];
          var start = moment(date.dateSelect[0], "YYYY-MM-DD");
          var end = moment(date.dateSelect[1], "YYYY-MM-DD");

          // Kiểm tra khoảng ngày hiện tại có lớn hơn 7, nếu lớn hơn thì enable tất cả, nếu ko thì xem khoảng ngày có ngày nào.
          let day = moment.duration(end.diff(start)).asDays();

          // Reset lại toàn bộ
          if (day < 6) {
            while (start <= end) {
              let daysOfWeek = this.formatDateOfWeek(start);
              // Mở các thứ ở trong khoảng
              date.weekdays.push(this.maxUpdate[daysOfWeek]);
              start = moment(start).add(1, "day");
            }
          } else {
            date.weekdays = [
              this.maxUpdate["priceFriday"],
              this.maxUpdate["priceMonday"],
              this.maxUpdate["priceSaturday"],
              this.maxUpdate["priceSunday"],
              this.maxUpdate["priceThursday"],
              this.maxUpdate["priceTuesday"],
              this.maxUpdate["priceWednesday"],
            ];
          }
          const sum = date.services.reduce(
            (previousValue, currentValue) => previousValue + +currentValue.price,
            0,
          );
          date.min = Math.min(...date.weekdays) - sum;
        });
      },
      deep: true,
    },
    tab(val) {
      if (val === "daily") {
        this.refresh();
      }
    },
  },
  methods: {
    handleInput(value, ind, code) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        const newVal = this.setCurrency(value);
        this.computedPrice(ind, code).set(newVal);
        this.reloadKey += 1;
        this.$nextTick(() => {
          const inputRef = this.$refs[`input_${ind}_${code}`];
          if (inputRef && inputRef[0]) {
            inputRef[0].focus();
          }
        });
      }, this.timeOutChange(value));
    },
    handleInputByDay(value, parentIdx, childrenIdx) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        const newVal = this.setCurrency(value);
        this.computedPriceByDay(parentIdx, childrenIdx).set(newVal);
        this.reloadKey += 1;
        this.$nextTick(() => {
          const inputRef = this.$refs[`row_${parentIdx}_service_${childrenIdx}`];
          if (inputRef && inputRef[0]) {
            inputRef[0].focus();
          }
        });
      }, this.timeOutChange(value));
    },
    changePercent(value, check) {
      if (value) {
        this.optionFormat = this.percentOptionsVi;
        if (check) {
          for (
            let index = 0;
            index < this.dataWeekly.roomRatePackagesDTO.roomRatePackageDTOS.length;
            index++
          ) {
            const e = this.dataWeekly.roomRatePackagesDTO.roomRatePackageDTOS[index];
            e.priceFriday = 0;
            e.priceMonday = 0;
            e.priceSaturday = 0;
            e.priceSunday = 0;
            e.priceThursday = 0;
            e.priceTuesday = 0;
            e.priceWednesday = 0;
          }
        }
        this.maxUpdate = {
          priceFriday: 100,
          priceMonday: 100,
          priceSaturday: 100,
          priceSunday: 100,
          priceThursday: 100,
          priceTuesday: 100,
          priceWednesday: 100,
        };
      } else {
        this.optionFormat =
          this.currency === "VND" ? this.priceOptionsVi : this.priceOptionsEn;
        this.maxUpdate = this.dataWeekly.minPriceRoomRate;
      }
    },
    validateMax(value) {
      var total = 0;
      total = this.dataWeekly.roomRatePackagesDTO.roomRatePackageDTOS.reduce(function (
        sum,
        e
      ) {
        return sum + +e[value];
      },
      0);
      return total <= this.maxUpdate[value];
    },
    validateMaxDaily(date) {
      // var total = 0;
      
      // total = date.services.reduce(function (sum, e) {
      //   return +sum + +e.price;
      // }, 0);
      return date.min >= 0;
    },
    refresh() {
      this.getRoomRatePackageWeekly(this.$route.params.id);
    },
    async getRoomRatePackageWeekly(data) {
      this.isLoading = true;
      await serviceCombo.getRoomRatePackageWeekly(data).then((res) => {
        if (res.responseCode === 0) {
          this.dataWeekly = res.data;
          if (this.dataWeekly.roomRatePackagesDTO.roomRatePackageDTOS[0].percent) {
            this.maxUpdate = {
              priceFriday: 100,
              priceMonday: 100,
              priceSaturday: 100,
              priceSunday: 100,
              priceThursday: 100,
              priceTuesday: 100,
              priceWednesday: 100,
            };
            this.optionFormat = this.percentOptionsVi;
          }
          this.changePercent(
            this.dataWeekly.roomRatePackagesDTO.roomRatePackageDTOS[0].percent, false
          );

          if (this.dataWeekly.roomRatePackagesDTO.roomRatePackageDTOS.length > 0) {
            const ob = this.dataWeekly.roomRatePackagesDTO.roomRatePackageDTOS;
            this.serviceOfRoomRate = ob.map((e) =>
              Object.assign(
                {},
                {
                  price: 0,
                  serviceStaticId: e.serviceStaticId,
                  roomRateId: e.roomRateId,
                  serviceStaticI18ns: e.serviceStaticMinimalDTO.serviceStaticI18ns,
                  nos: e.nos
                }
              )
            );
          }
          this.isLoading = false;
          // this.$refs.formUpdate.validate();
        }
      });
    },

    confirmUpdatePriceWeekly() {
      let isValidFrom = this.$refs.formUpdate.validate();
      if (!isValidFrom) {
        this.$refs.confirmDialogComponent.open({});
      } else {
        this.updatePriceWeekly();
      }
     
    },
    updatePriceWeekly() {
      let body = this.dataWeekly.roomRatePackagesDTO.roomRatePackageDTOS.map((e) =>
        Object.assign(
          {},
          {
            id: e.id,
            nos: e.nos,
            percent: this.dataWeekly.roomRatePackagesDTO.roomRatePackageDTOS[0].percent,
            priceFriday: +e.priceFriday,
            priceMonday: +e.priceMonday,
            priceSaturday: +e.priceSaturday,
            priceSunday: +e.priceSunday,
            priceThursday: +e.priceThursday,
            priceTuesday: +e.priceTuesday,
            priceWednesday: +e.priceWednesday,
            roomRateId: e.roomRateId,
            serviceStaticId: e.serviceStaticId,
            action: 2,
            status: true,
          }
        )
      );

      serviceCombo.updateRoomRatePackageList(body).then((res) => {
        _alert(res, this.$t(res.data), false);
        this.refresh();
      });
    },
    copyPrice(sv) {
      sv.priceFriday = sv.priceMonday;
      sv.priceSaturday = sv.priceMonday;
      sv.priceSunday = sv.priceMonday;
      sv.priceThursday = sv.priceMonday;
      sv.priceTuesday = sv.priceMonday;
      sv.priceWednesday = sv.priceMonday;
    },
    _formatCurrency: _formatCurrency,
    formatDate: _formatDate,

    async getRoomRatePackageDaily() {
      this.isLoading = true;
      await serviceCombo.getRoomRatePackageDaily().then((res) => {
        if (res.responseCode === 0 && res.data.length > 0) {
          const data = res.data
            .filter((e) => e.roomRateId === this.$route.params.id)
            .map((date) =>
              Object.assign(
                {},
                {
                  startDate: date.startDate,
                  endDate: date.endDate,
                  action: 2,
                  services: [],
                }
              )
            );
          this.dataDaily = Array.from(new Set(data.map(JSON.stringify))).map(JSON.parse);
          this.dataDaily.forEach((e) => {
            res.data.filter((e) => e.roomRateId === this.$route.params.id).forEach((item) => {
              if (item.startDate === e.startDate && item.endDate === e.endDate && this.dataWeekly.roomRatePackagesDTO.roomRatePackageDTOS.find(
                    (sv) => sv.serviceStaticId === item.serviceStaticId
                  ) ) {
                e.services.push({
                  id: item.id,
                  price: item.price,
                  serviceStaticId: item.serviceStaticId,
                  roomRateId: item.roomRateId,
                  serviceStaticI18ns: this.dataWeekly.roomRatePackagesDTO.roomRatePackageDTOS.find(
                    (sv) => sv.serviceStaticId === item.serviceStaticId
                  ).serviceStaticMinimalDTO.serviceStaticI18ns,
                  nos: item.nos
                });
              }
            });
          });
          this.massDate = this.dataDaily.map((e) =>
            Object.assign(
              {},
              {
                id: e.id,
                dateSelect: [new Date(e.startDate), new Date(e.endDate)],
                action: e.action,
                services: JSON.parse(JSON.stringify(e.services)),
              }
            )
          );
          this.isLoading = false;
        } else {
          this.isLoading = false;
        }
      });
      // this.$refs.formUpdateDaily.validate();
    },
    addDateSpecial() {
      let prevPeriod =
        this.massDate.length > 0 ? this.massDate[this.massDate.length - 1] : null;
      if (!prevPeriod) {
        this.massDate.push({
          action: 1,
          dateSelect: [
            new Date(moment(this.currentDate).format("YYYY-MM-DD")),
            new Date(moment(this.currentDate).add(1, "day").format("YYYY-MM-DD")),
          ],
          services: JSON.parse(JSON.stringify(this.serviceOfRoomRate)),
        });
        return;
      }
      const tomorrow = new Date();
      tomorrow.setDate(new Date().getDate() + 365 * 2);
      if (new Date(moment(prevPeriod.dateSelect[1]).format("YYYY-MM-DD")) >= tomorrow) {
        return;
      }
      let from = moment(prevPeriod.dateSelect[1]).add(1, "day").format("YYYY-MM-DD");
      let to = moment(prevPeriod.dateSelect[1]).add(2, "day").format("YYYY-MM-DD");
      this.massDate.push({
        action: 1,
        dateSelect: [new Date(from), new Date(to)],
        services: JSON.parse(JSON.stringify(this.serviceOfRoomRate)),
      });
    },
    confirmUpdatePriceDaily() {
      let isValidFrom = this.$refs.formUpdateDaily.validate();
      if (!isValidFrom) {
        this.$refs.confirmDailyDialogComponent.open(null)
      } else {
        this.updatePriceDaily()
      }
     
    },
    updatePriceDaily() {
      let body = [];
      this.massDate.forEach((date) => {
        date.services.forEach((sv) => {
          body.push({
            id: sv.id ? sv.id : null,
            action: date.action,
            startDate: moment(date.dateSelect[0]).format("YYYY-MM-DD"),
            endDate: moment(date.dateSelect[1]).format("YYYY-MM-DD"),
            price: sv.price,
            serviceStaticId: sv.serviceStaticId,
            roomRateId: sv.roomRateId,
          });
        });
      });

      serviceCombo.updateRoomRatePackageListDaily(body).then((res) => {
        _alert(res, this.$t(res.data), false);
        this.refresh();
      });
    },
    formatDateOfWeek(date) {
      let dayOfWeek;
      switch (date.day()) {
        case 0: {
          dayOfWeek = "priceSunday";
          break;
        }
        case 1: {
          dayOfWeek = "priceMonday";
          break;
        }
        case 2: {
          dayOfWeek = "priceTuesday";
          break;
        }
        case 3: {
          dayOfWeek = "priceWednesday";
          break;
        }
        case 4: {
          dayOfWeek = "priceThursday";
          break;
        }
        case 5: {
          dayOfWeek = "priceFriday";
          break;
        }
        case 6: {
          dayOfWeek = "priceSaturday";
          break;
        }
      }
      return dayOfWeek;
    },
    _moment: moment,
  },
};
</script>
